import axios from 'axios';
import routes from './routes';

const baseUrl = process.env.REACT_APP_BASE_URL;

const ProofOfDeliveryServices = {
  getOrderDetails: async (orderCode) => {
    try {
      const response = await axios.get(`${baseUrl}/api${routes.getOrderDetails}?orderCode=${encodeURIComponent(orderCode)}`);
      return response.data;
    } catch (error) {
      console.error('Order details fetch failed:', error);
      throw error;
    }
  },
  uploadFiles: async (orderCode, files) => {
    const formData = new FormData();
    formData.append('orderCode', orderCode);
    files.forEach(file => {
      formData.append('files', file);
    });

    try {
      const response = await axios.post(`${baseUrl}/api${routes.uploadFiles}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('File upload failed:', error);
      throw error;
    }
  },
};

export default ProofOfDeliveryServices;